import Form_11 from './Form_11-redux';

export default Form_11;
